import { useEffect } from 'react';

import { ReferencedEntry } from 'contentful';
import { Navigation } from 'src/api/contentful/contentTypes.cloverdotcom';
import { useNavBarContext } from 'src/components/NavBarContext/NavBarContext';

export const useNavBar = (headerUtil?: ReferencedEntry<Navigation>, header?: ReferencedEntry<Navigation>, hideCartIcon?: boolean) => {
  const { setHeaderOverride, clearHeaderOverride, setHeaderUtilOverride, clearHeaderUtilOverride, setHideCartIcon, clearHideCartIcon } = useNavBarContext();

  useEffect(() => {

    if (header) {
      setHeaderOverride(header);
    }

    if (headerUtil) {
      setHeaderUtilOverride(headerUtil);
    }

    if (hideCartIcon) {
      setHideCartIcon(hideCartIcon);
    }

    return () => {
      clearHeaderOverride();
      clearHeaderUtilOverride();
      clearHideCartIcon();
    };

  }, [header, headerUtil, hideCartIcon]);
};
